import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router"

import Card from "ui/components/Card"
import Table from "ui/components/Table"
import Text from "ui/components/Text"

const ObjectTable = props => {
    const columns = [
        {
            accessor: "name",
            Header: "Name",
            Cell: cell => (
                <Link to={"/table/" + cell.original._sid}>
                    <Text margin={"none"}>{cell.original.name}</Text>
                </Link>
            ),
        },
    ]

    return (
        <Card>
            <Table columns={columns} data={props.data} dataLabel="tables" />
        </Card>
    )
}

ObjectTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
}

export default ObjectTable



// WEBPACK FOOTER //
// ./src/features/studio/components/ObjectTable.js